import { POST, PUT } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return `/purchases/${endpoint}`;
};

export const getPurchases = (request, token) => {
  const endpoint = getEndpointWithPrefix('getPurchases');
  return POST(endpoint, request, token);
};

export const searchPurchases = (request, token) => {
  const endpoint = getEndpointWithPrefix('searchById');
  return POST(endpoint, request, token);
};

export const filterPurchases = (request, token) => {
  const endpoint = getEndpointWithPrefix('filterByDate');
  return POST(endpoint, request, token);
};

export const changePaymentMethod = (request, token) => {
  const endpoint = getEndpointWithPrefix('change-payment-method');
  return PUT(endpoint, request, token);
};

export const editPendingPurchaseDetails = (request, token) => {
  const endpoint = getEndpointWithPrefix('update/details');
  return PUT(endpoint, request, token);
};

export const downloadPurchasesCSV = (request, token) => {
  const endpoint = getEndpointWithPrefix('get-purchase-csv');
  return POST(endpoint, request, token);
};
